<template>
  <div>
    <!-- 对话框 -->
    <el-dialog :visible.sync="centerDialogVisible" width="36%" center>
      <span slot="title" class="title">会议</span>
      <div class="wire"></div>
      <div class="dialogue">
        <span>主</span>
        <span>题:</span>
        <span>{{ tableData.btitle }}</span>
      </div>
      <div class="dialogue2">
        <span>会议地点:</span>
        <span>{{ tableData.address }}</span>
      </div>
      <div class="dialogue2">
        <span>会议时间:</span>
        <span>{{ tableData.ctime | dateFilter }}</span>
      </div>
      <div class="dialogue3">
        <span>内</span>
        <span>容:</span>
        <el-input
          class="input"
          type="textarea"
          v-model="tableData.content"
          maxlength="200"
          show-word-limit
          placeholder="请填写内容"
          resize="none"
          :rows="8"
          :disabled="true"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
        <el-button
          type="primary"
          @click="joinChange"
          v-if="tableData.state == 1"
          >报名</el-button
        >
        <el-button
          type="primary"
          @click="cancelChange"
          v-if="tableData.state == 2"
          >取消报名</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { applyData } from "../../api/backstage";
export default {
  data() {
    return {
      centerDialogVisible: false,
      desc: "",
      tableData: {},
    };
  },
  created() {},
  methods: {
    joinChange() {
      applyData(
        "/index/memberEnroll",
        this.tableData.ID,
        this.aid,
        this.tableData.type
      ).then((res) => {
        if (res.code == 1) {
          this.tableData.msize = res.msize;
          this.centerDialogVisible = false;
          this.tableData.state = 2;
          this.$message({
            message: "恭喜你，报名成功",
            type: "success",
          });
        } else if (res.code == -1) {
          this.$message.error("数据异常");
        } else if (res.code == 1001) {
          this.$alert("请先登录", "警告", {
            confirmButtonText: "确定",
            type: "warning",
            callback: () => {
              this.$router.push("/login");
            },
          });
        }
      });
    },
    cancelChange() {
      this.$confirm("是否取消报名？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "放弃修改",
      })
        .then(() => {
          applyData(
            "/index/delMemberEnroll",
            this.tableData.ID,
            this.aid,
            this.tableData.type
          ).then((res) => {
            if (res.code == 1) {
              this.tableData.msize = res.msize;
              this.tableData.state = 1;
              this.centerDialogVisible = false;
              this.$message({
                type: "info",
                message: "取消报名成功",
              });
            } else if (res.code == -1) {
              this.$message.error("数据异常");
            } else if (res.code == 1001) {
              this.$alert("请先登录", "警告", {
                confirmButtonText: "确定",
                type: "warning",
                callback: () => {
                  this.$router.push("/login");
                },
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已放弃修改",
          });
        });
    },
  },
  filters: {
    dateFilter(i) {
      var myDate = new Date(i);
      return (
        myDate.getFullYear() +
        "." +
        (myDate.getMonth() + 1) +
        "." +
        myDate.getDate() +
        " " +
        myDate.getHours() +
        ":" +
        myDate.getMinutes()
      );
    },
  },
  computed: {
    aid() {
      return this.$store.state.userInfo.AID;
    },
  },
};
</script>

<style scoped lang="less">
.title {
  font-weight: bold;
  font-size: 24px;
}
.wire {
  width: 100%;
  height: 1px;
  background: #efefef;
  border: 1px solid #9a9a9a;
  margin-bottom: 20px;
}
.dialogue {
  margin-bottom: 20px;
  span:nth-child(1),
  span:nth-child(2) {
    font-size: 18px;
    color: #9a9a9a;
  }
  span:nth-child(2) {
    margin-left: 2em;
    margin-right: 10px;
  }
  span:nth-child(3) {
    font-size: 20px;
    font-weight: bold;
  }
}
.dialogue2 {
  margin-bottom: 20px;
  span:nth-child(1) {
    font-size: 18px;
    color: #9a9a9a;
    margin-right: 10px;
  }
  span:nth-child(2) {
    font-size: 20px;
    font-weight: bold;
  }
}
.dialogue3 {
  margin-bottom: 20px;
  display: flex;
  span:nth-child(1),
  span:nth-child(2) {
    font-size: 18px;
    color: #9a9a9a;
  }
  span:nth-child(2) {
    margin-left: 2em;
    margin-right: 10px;
  }
  .input {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #343434;
  }
}
</style>
